module.exports = __webpack_public_path__ + "static/media/3.9a10c202.jpg";